/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { changeRetirementDatePostRequestSchema } from './changeRetirementDatePostRequestSchema.ts';
import { changeRetirementDatePostResponseSchema } from './changeRetirementDatePostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postChangeRetirementDate200Schema = z.lazy(() => changeRetirementDatePostResponseSchema);

/**
 * @description 505 response
 */
export const postChangeRetirementDate505Schema = z.any();

export const postChangeRetirementDateMutationRequestSchema = z.lazy(() => changeRetirementDatePostRequestSchema);

export const postChangeRetirementDateMutationResponseSchema = z.lazy(() => postChangeRetirementDate200Schema);
